<header class="app-header" [class.app-header--scrolled]="headerElevated()">
  <button
    type="button"
    class="menu-btn"
    [attr.aria-label]="'header.actions.toggleNavigation' | translate"
    (click)="onMenuClick()"
  >
    <span class="menu-icon" aria-hidden="true"></span>
  </button>

  <h1 class="page-title">
    @if (moduleLabelKey(); as labelKey) {
      {{ labelKey | translate }}
    } @else {
      {{ routeTitle() | translate }}
    }
  </h1>

  <div class="header-actions">
    @if (!isSuperAdmin()) {
      <div class="header-org-select-wrap">
        <p-select
        [options]="organizationOptions()"
        optionLabel="tenantName"
        dataKey="tenantId"
        [ngModel]="selectedOrganization()"
        (ngModelChange)="onOrganizationChange($event)"
        [placeholder]="'signUp.form.selectOrganization' | translate"
        [loading]="isSwitchingTenant()"
        [disabled]="isSwitchingTenant()"
        appendTo="body"
        styleClass="header-org-select"
        [attr.aria-label]="'signUp.form.selectOrganization' | translate"
        [attr.aria-busy]="isSwitchingTenant()"
        [pt]="{
          root: {
            class:
              '!w-full !min-h-10 !rounded-[10px] !border !border-[color:var(--theme-border)] !bg-[color:var(--theme-surface-elevated)] !shadow-[0_1px_2px_rgba(15,23,42,0.05)]',
          },
          label: { class: '!flex !items-center !gap-2 !py-2 !px-3 !text-sm !font-medium' },
          dropdown: { class: '!w-6 !text-[color:var(--theme-text-secondary)]' },
        }"
      >
        <ng-template pTemplate="selectedItem" let-org>
          @if (org) {
            <span class="header-org-select__value">
              @if (showOrganizationLogo(org)) {
                <img
                  class="header-org-select__logo"
                  [src]="organizationLogo(org)"
                  [alt]="org.tenantName"
                  width="20"
                  height="20"
                  loading="lazy"
                  (error)="onOrganizationLogoError(org)"
                />
              } @else {
                <span class="header-org-select__logo-fallback" aria-hidden="true">
                  <i class="pi pi-building"></i>
                </span>
              }
              <span class="header-org-select__name">{{ org.tenantName }}</span>
            </span>
          }
        </ng-template>

        <ng-template pTemplate="item" let-org>
          <span class="header-org-select__item">
            @if (showOrganizationLogo(org)) {
              <img
                class="header-org-select__logo"
                [src]="organizationLogo(org)"
                [alt]="org.tenantName"
                width="20"
                height="20"
                loading="lazy"
                (error)="onOrganizationLogoError(org)"
              />
            } @else {
              <span class="header-org-select__logo-fallback" aria-hidden="true">
                <i class="pi pi-building"></i>
              </span>
            }
            <span class="header-org-select__name">{{ org.tenantName }}</span>
          </span>
        </ng-template>
      </p-select>
      </div>
    }
    <!-- Notification icon (disabled until in-app notifications are wired)
    <button
      type="button"
      class="notify-btn"
      [attr.aria-label]="'header.actions.notifications' | translate"
    >
      <i class="pi pi-bell" aria-hidden="true"></i>
      <span class="notify-dot" aria-hidden="true"></span>
    </button>
    -->

    <app-language-switcher [appendTo]="'self'" />
    <app-theme-toggle />
  </div>
</header>
